import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { WorkSessionProvider } from './context/WorkSessionContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <WorkSessionProvider>
        <App />
      </WorkSessionProvider>
    </AuthProvider>
  </React.StrictMode>
);
